module.exports = __webpack_public_path__ + "img/stats.f57d3838.png";